import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Spinner } from "@phosphor-icons/react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const t = useT();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const [tokens, setTokens] = useState(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setTokens(data.tokens);
          setStatus("paid");
          refresh();
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (e) { console.debug("payment status poll retry:", e?.message); }
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
    /* eslint-disable-next-line */
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-md" data-testid="payment-success">
        {status === "checking" && <><Spinner size={56} className="text-muted-foreground animate-spin mx-auto" /><p className="mt-6 text-muted-foreground">{t("pay.checking")}</p></>}
        {status === "paid" && <>
          <CheckCircle weight="fill" size={72} className="text-medical mx-auto" />
          <h1 className="text-3xl font-extrabold mt-4">{t("pay.success")}</h1>
          <p className="text-muted-foreground mt-2">{t("pay.added", { n: tokens })}</p>
          <Button className="mt-6" onClick={() => nav("/dashboard")} data-testid="success-continue">{t("pay.backDash")}</Button>
        </>}
        {status === "pending" && <><Spinner size={56} className="text-warn mx-auto" /><p className="mt-6 text-muted-foreground">{t("pay.pending")}</p><Button className="mt-6" onClick={() => nav("/dashboard")}>{t("pay.dashboard")}</Button></>}
        {status === "error" && <><XCircle weight="fill" size={72} className="text-hong mx-auto" /><h1 className="text-2xl font-bold mt-4">{t("pay.error")}</h1><Button className="mt-6" onClick={() => nav("/billing")}>{t("pay.retry")}</Button></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const t = useT();
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center" data-testid="payment-cancel">
        <XCircle weight="fill" size={72} className="text-muted-foreground mx-auto" />
        <h1 className="text-2xl font-bold mt-4">{t("pay.cancelled")}</h1>
        <Link to="/billing"><Button className="mt-6">{t("pay.backPackages")}</Button></Link>
      </div>
    </div>
  );
}
